<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="selected(rowKey.data)">选择</a>
        </span>
      </template>
    </standard-table>
  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
let organizationOptions = [];
let departmentOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom
  },
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "姓名"
        },
        {
          type: "input",
          key: "telephone",
          name: "电话"
        },
        {
          type: "select",
          key: "organizationId",
          name: "销售组织",
          options: []
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "姓名",
          dataIndex: "name",
          sorter: true
        },
        {
          title: "电话",
          dataIndex: "telephone",
          width: 150
        },
        {
          title: "员工编号",
          dataIndex: "code",
          width: 150
        },
        {
          title: "销售组织",
          dataIndex: "organizationName",
          width: 250
        },
        {
          title: "部门",
          dataIndex: "departmentName",
          width: 200
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", isActive: null },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "400px",
      selectedRowKeys: [],
      rowSelection: null,
      title: "",
      onlySale: false
    };
  },
  async created() {
    await this.getOrganizationOptions();
  },
  async mounted() {
    if (
      this.paramsX &&
      this.paramsX.organizationId &&
      this.paramsX.organizationId > 0
    ) {
      this.filter = this.filter.filter(a => a.key != "organizationId");
    }
    if (this.paramsX && this.paramsX.onlySale) {
      this.onlySale = true;
    }
    if (!this.onlySale) {
      this.columns = this.columns.filter(a => a.dataIndex != "departmentName");
    }
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.name = p.values.name;
      this.filterdata.code = p.values.code;
      this.filterdata.telephone = p.values.telephone;
      this.filterdata.organizationId = p.values.organizationId;
      this.filterdata.departmentId = p.values.departmentId;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    selected(record) {
      this.$emit("getSelectedEmployee", {
        id: record.id,
        name: record.name,
        telephone: record.telephone,
        organizationId: record.organizationId
      });
    },
    async getOrganizationOptions() {
      organizationOptions = [];
      let orgList = await api.GetOrganizationSelect();
      if (orgList) {
        orgList.forEach(a => {
          organizationOptions.push({
            name: a.text,
            val: a.value
          });
        });
        this.filter.filter(
          a => a.key == "organizationId"
        )[0].options = organizationOptions;
      }
    },
    async getDepartmentOptions(orgId) {
      departmentOptions = [];
      let departmentList = await api.GetDepartmentSelect({ orgId: orgId });
      if (departmentList) {
        departmentList.forEach(a => {
          departmentOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      options.isActive = 1;
      if (
        this.paramsX &&
        this.paramsX.organizationId &&
        this.paramsX.organizationId > 0
      ) {
        options.organizationId = this.paramsX.organizationId;
      }

      if (
        this.paramsX &&
        this.paramsX.departmentId &&
        this.paramsX.departmentId > 0
      ) {
        options.departmentId = this.paramsX.departmentId;
      }

      let data = this.onlySale
        ? await api.GetSaleEmployeePaged(options)
        : await api.GetEmployeeList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Basic/Employee/SelectList.vue